// The server sends LocalDateTime strings with no timezone (e.g. "2026-04-14T15:30:00").
// JavaScript's Date() would treat that as local time, which is wrong — the server is UTC.
// Append 'Z' when missing so we parse it as UTC and Date arithmetic is correct across
// viewer timezones.
//
// Memoized: called many times per row across several useMemos, and the strings are
// immutable. The cache is bounded by the distinct timestamps on the page.
const _parseTimeCache = new Map();

export function parseServerTime(s) {
  if (!s) return null;
  const hit = _parseTimeCache.get(s);
  if (hit !== undefined) return hit;
  const hasTz = /Z$|[+-]\d{2}:?\d{2}$/.test(s);
  const d = new Date(hasTz ? s : s + 'Z');
  _parseTimeCache.set(s, d);
  return d;
}
